import { render, staticRenderFns } from "./FrameworkListFramework.vue?vue&type=template&id=140026dd"
import script from "./FrameworkListFramework.vue?vue&type=script&lang=js"
export * from "./FrameworkListFramework.vue?vue&type=script&lang=js"
import style0 from "./FrameworkListFramework.vue?vue&type=style&index=0&id=140026dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports